import type { ReactElement } from 'react';
import { Link } from 'react-router';

import type { BackState } from '@/lib/back-nav';

import { attributionText, reworkHours, transitionText } from '../presentation';
import type { ReworkEvent } from '../types';
import { formatDateTime } from '@/lib/time';

// Lista de devoluciones (spec 2026-10-14 §5): la comparten la tarjeta de la ficha y el
// diálogo por persona del Estudio de tiempos. Con `backState`, cada código lleva a la
// ficha del documento con regreso a la pantalla de origen.

export function ReworkEventList({
  events,
  backState,
}: {
  events: ReworkEvent[];
  backState?: BackState;
}): ReactElement {
  return (
    <ul className="rw-list">
      {events.map((e) => (
        <li key={e.id} className="rw-item">
          <div className="rw-head">
            {backState !== undefined && (
              <Link
                to={`/documentos/${encodeURIComponent(e.entryId)}`}
                state={backState}
                className="code"
              >
                {e.code ?? 'Documento'}
              </Link>
            )}
            <span className="rw-step">{transitionText(e)}</span>
            <span className="soft">{formatDateTime(e.occurredAt)}</span>
          </div>
          <p className="rw-reason">{e.reason}</p>
          <p className="rw-meta">
            {`${attributionText(e)} · Devolvió ${e.returnedByName ?? 'usuario sin nombre'} · ${reworkHours(e)}`}
          </p>
        </li>
      ))}
    </ul>
  );
}
